import PopupInvoicesList from './PopupInvoicesList';

export default PopupInvoicesList;
